export default "__VITE_ASSET__d2507372__"